// Lodash
window._ = require("lodash");

try {
  // jQuery and Bootstrap JS
  window.$ = window.jQuery = require("jquery");
  require("bootstrap");
} catch (e) {}

// activate bootstrap tooltip and popover
$(function() {
  $('[data-toggle="tooltip"]').tooltip();
});

// TinyMCE
import Url from "./helpers/Url";
require("tinymce");
tinyMCE.baseURL = Url.base + "/js/vendor/tinymce";

// Axios
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
  axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
}

// Vue
import VueAxios from "vue-axios";
import Vue from 'vue';
window.Vue = Vue;
Vue.use(VueAxios, axios);

// CSS Variables Ponyfill
import cssVars from "css-vars-ponyfill";
cssVars();
